import { render, staticRenderFns } from "./ffmember.vue?vue&type=template&id=72304431&"
import script from "./ffmember.vue?vue&type=script&lang=js&"
export * from "./ffmember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports